<template>
  <div>
     <section id="agen" class="section-atozagen pd-section">
      <div class="container">
        <div class="row">
          <img class="section-atozagen__img d-md-block d-none" data-aos="zoom-in-down" src="images/merchant.png"
            alt="merchant-img">
          <img class="section-atozagen__img--mobile d-md-none d-sm-block d-none" data-aos="zoom-in-down"
            src="images/agen-people.webp" alt="merchant-img">

          <div class="col-md-6 offset-md-6 py-5">
            <h2>Tambah penghasilan dengan atozpay agen</h2>
            <p>Maksimalkan penghasilan usahamu hingga jutaan rupiah
              dan dapatkan keuntungan di setiap transaksi.</p>
            <a href="https://agen.atozpay.co.id/" target="_blank" rel="noopener" class="hvr-underline-from-left"
              title="Selengkapnya">Lebih lagi</a>

            <div class="text-lg-left text-center mt-5">
              <a href="https://play.google.com/store/apps/details?id=id.co.atozagen" target="_blank" rel="noopener">
                <button class="section-atozagen--cta">Daftar Agen</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: "Atozgagen"
  }
</script>

<style scoped>

</style>